import PlayerLevelTag from 'components/PlayerLevelTag';
import useIsMobile from 'hooks/useIsMobile';
import React from 'react'

const StandingsPlayerLevelCell = ({ listPlayerLevel, className, sorted, align }) => {
  const isMobile = useIsMobile();

  return (
    <div className={
      `table-cell align-middle py-2 pl-2 first:pl-2 pr-2 last:pr-2 ` +
      `font-thin text-[#696969] border-gray-300 border-b-[1px] ` +
      `align-middle` +
      `${sorted ? 'bg-gray-100 !font-normal' : ''} ` +
      `${!isMobile ? 'text-[1.25rem]' : 'text-[0.9rem]'} ` +
      `${align == 'left' ? 'text-left' : 'text-right'} ` +
      `${className}`
    }>
          <PlayerLevelTag listPlayerLevel={listPlayerLevel} className="font-normal text-[0.8em]" />      
    </div>
  )
}

export default StandingsPlayerLevelCell